// extracted by mini-css-extract-plugin
export default {"orange_btn":"Button_orange_btn__qefRm","active":"Button_active__0jiA0","price":"Button_price__CpGwK","green_btn":"Button_green_btn__lZAsM"};